module.exports = __webpack_public_path__ + "img/installmentPayments.421688de.svg";